<template>
  <section class="plans">
    <!-- Header -->
    <header class="plans-head">
      <div class="plans-intro">
        <span class="step-pill">STEP 2</span>
        <h1 class="plans-title">Select a Plan</h1>
        <p class="plans-desc">
          Choose from Free to Premium Plans to Practice PTE Test with Quality Practice
          Material and state of art AI (Artificial Intelligence) modules
        </p>
      </div>

      

      <!-- <img v-if="heroImage" :src="heroImage" alt="" class="plans-hero" /> -->
    </header>

    <!-- Plan cards -->
    <div class="plan-grid">
      <article v-for="plan in plans" :key="plan.id"
               :class="['plan-card', { featured: plan.popular }]">
        <span v-if="plan.popular" class="popular-badge">MOST POPULAR</span>

        <h3 class="plan-name">{{ plan.name }}</h3>
        <div class="plan-price">
          <span class="amount">{{ plan.price }}</span>
          <span class="period">/ {{ plan.period }}</span>
        </div>
        <p class="plan-tagline">{{ plan.tagline }}</p>

        <ul class="plan-features">
          <li v-for="f in plan.features" :key="f">
            <svg class="check" viewBox="0 0 20 20" aria-hidden="true">
              <circle cx="10" cy="10" r="9" />
              <path d="M6 10.2l2.7 2.6L14 7.5" />
            </svg>
            <span>{{ f }}</span>
          </li>
        </ul>

        <button type="button"
                :class="['plan-btn', plan.popular ? 'solid' : 'outline']"
                @click="$emit('select', plan)">
          {{ plan.cta || 'Buy Now' }}
        </button>
      </article>
    </div>

    <!-- Feature strip -->
    <div class="feature-strip">
      <div class="feature">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path class="fill" d="M7 3h10v5a5 5 0 0 1-10 0z" /><path d="M7 5H4v2a3 3 0 0 0 3 3M17 5h3v2a3 3 0 0 1-3 3M12 13v4M8 21h8M9 17h6" /></svg>
        <span>Practice Anytime</span>
      </div>
      <div class="feature">
        <svg viewBox="0 0 24 24" aria-hidden="true"><rect class="fill" x="4" y="13" width="4" height="7" rx="1" /><rect class="fill" x="10" y="9" width="4" height="11" rx="1" /><rect class="fill" x="16" y="4" width="4" height="16" rx="1" /></svg>
        <span>Track Progress</span>
      </div>
      <div class="feature">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path class="fill" d="M9 3a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 2 5 3 3 0 0 0 3 3 3 3 0 0 0 3-1V4a3 3 0 0 0-3-1zM15 3a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3 3 0 0 1-2 5 3 3 0 0 1-3 3 3 3 0 0 1-3-1V4a3 3 0 0 1 3-1z" /></svg>
        <span>AI-Powered Learning</span>
      </div>
      <div class="feature">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle class="fill" cx="9" cy="8" r="3.5" /><circle class="fill" cx="17" cy="9" r="2.8" /><path class="fill" d="M2 20a7 7 0 0 1 14 0zM14 20a5.5 5.5 0 0 1 8 0z" /></svg>
        <span>Trusted by Thousands</span>
      </div>

      <!-- <div class="hand-note note-bottom" aria-hidden="true">
        Small Steps<br />Big Results!
        <svg viewBox="0 0 120 12"><path d="M2 10 C 40 3, 80 2, 118 4" /></svg>
      </div> -->
    </div>
  </section>
</template>

<script>
// Plan ids are placeholders — map them to the ids your payment/checkout flow uses.
const DEFAULT_PLANS = [
  {
    id: 'free', name: 'Free Plan', price: '$0', period: 'forever', cta: 'Join For Free',
    tagline: 'Try PTEClasses with no commitment.',
    features: ['Limited access materials', 'Mock test scoring', 'AI public scoring', 'Limited question scoring']
  },
  {
    id: 'plan7', name: '7 Day Plan', price: '$5.99', period: '7 days', popular: true,
    tagline: 'Perfect for a quick exam sprint.',
    features: ['Unlimited access materials', 'Unlimited mock test scoring', 'Unlimited AI speaking scoring',
               'Unlimited reading scoring', 'Highlighter tool', 'Predicted questions']
  },
  {
    id: 'plan14', name: '14 Day Acceleration', price: '$7.99', period: '14 days',
    tagline: 'Build momentum before test day.',
    features: ['Expanded access materials', 'Unlimited mock test scoring', 'Unlimited AI speaking scoring',
               'Unlimited reading scoring', 'Mock vault access', 'Predicted questions']
  },
  {
    id: 'plan30', name: '30 Day Mastery', price: '$10.99', period: '30 days',
    tagline: 'Our most popular full prep plan.',
    features: ['Complete access materials', 'Unlimited mock test scoring', 'Unlimited AI speaking scoring',
               'Mock tests + templates', 'Email suggestions', 'Predicted questions']
  },
  {
    id: 'plan60', name: '60 Day Transformation', price: '$25.99', period: '60 days',
    tagline: 'Maximum practice for a top score.',
    features: ['Complete access materials', 'Unlimited mock test scoring', 'Unlimited AI speaking scoring',
               'Mock tests + templates', 'Email suggestions', 'Predicted questions']
  },
  {
    id: 'practiceTest', name: 'PTE Practice Test', price: '$50', period: 'one-off',
    tagline: 'A full simulated, scored mock exam.',
    features: ['Comprehensive test materials', 'Detailed mock score report', 'Identify weaknesses & strategy',
               'Comprehensive AI speaking scoring', 'Real-time PTE score simulation', 'Access to all sections']
  }
];

export default {
  name: 'PlanSelector',
  props: {
    plans: { type: Array, default: () => DEFAULT_PLANS },
    heroImage: { type: String, default: null }
  }
};
</script>

<style scoped>
.plans {
  --pc-primary: #1463f3;
  --pc-primary-dark: #0d4fd1;
  --pc-navy: #0f1d4a;
  --pc-text: #1f2937;
  --pc-muted: #5b6475;
  --pc-border: #e3e8f1;
  --pc-green: #22a447;
  font-family: 'Poppins', 'Segoe UI', system-ui, sans-serif;
  color: var(--pc-text);
  position: relative;
}

/* ---------- Header ---------- */
.plans-head { position: relative; min-height: 150px; padding-right: 330px; margin-bottom: 10px; }
.step-pill {
  display: inline-block; background: #dbe7ff; color: var(--pc-primary);
  font-size: 12px; font-weight: 600; letter-spacing: .5px;
  padding: 4px 12px; border-radius: 999px; margin-bottom: 8px;
}
.plans-title { font-size: 28px; font-weight: 700;text-transform: capitalize; color: var(--pc-navy); margin: 0 0 10px; letter-spacing: -.5px; }
.plans-desc { font-size: 14px; line-height: 1.45; color: var(--pc-muted); margin: 0; max-width: 560px; }
/* .plans-hero {
  position: absolute; right: 3vw; bottom: -24px; width: 320px; max-height: 210px;
  object-fit: contain; object-position: bottom right; pointer-events: none;
} */

/* Handwritten notes */
.hand-note {
  font-family: 'Caveat', 'Segoe Script', cursive; color: var(--pc-navy);
  font-size: 20px; line-height: 1.05; transform: rotate(-12deg);
}
.hand-note svg { display: block; width: 90px; height: 10px; fill: none; stroke: #e11d48; stroke-width: 2.5; stroke-linecap: round; }
.note-top { position: absolute; right: 22vw; top: 0; }

/* ---------- Grid ---------- */
.plan-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.plan-card {
  position: relative; display: flex; flex-direction: column;
  background: #fff; border: 1px solid var(--pc-border); border-radius: 14px;
  padding: 10px 22px 10px; box-shadow: 0 6px 22px rgba(20, 60, 140, .06);
  transition: transform .2s, box-shadow .2s;
}
.plan-card:hover { transform: translateY(-3px); box-shadow: 0 12px 28px rgba(20, 60, 140, .12); }
.plan-card.featured { border: 2px solid #9fbdf8; box-shadow: 0 10px 30px rgba(20, 99, 243, .15); }
.popular-badge {
  position: absolute; top: -22px; left: 50%; transform: translateX(-50%);
  background: var(--pc-primary); color: #fff; font-size: 12px; font-weight: 600;
  padding: 4px 14px; border-radius: 999px; white-space: nowrap;
}
.plan-name { font-size: 15px; font-weight: 700; color: var(--pc-primary); margin: 0 0 6px; }
.plan-price { display: flex; align-items: baseline; gap: 6px; }
.plan-price .amount { font-size: 30px; font-weight: 800; color: var(--pc-navy); line-height: 1.1; }
.plan-price .period { font-size: 14px; color: var(--pc-muted); }
.plan-tagline { font-size: 12px; color: var(--pc-muted); margin: 4px 0 14px; }

.plan-features { list-style: none; padding: 0; margin: 0 0 12px; flex: 1; }
.plan-features li { display: flex; align-items: flex-start; gap: 8px; font-size: 12px; margin-bottom: 6px; line-height: 1.15; }
.check { flex: 0 0 18px; width: 14px; height: 14px; margin-top: 1px; }
.check circle { fill: var(--pc-green); }
.check path { fill: none; stroke: #fff; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }

.plan-btn {
  width: 100%; height: 44px; border-radius: 999px; font-size: 15px; font-weight: 600;
  cursor: pointer; transition: background .2s, color .2s;
}
.plan-btn.outline { background: #fff; color: var(--pc-primary)!important; border: 1.5px solid var(--pc-primary); }
.plan-btn.outline:hover { background: var(--pc-primary); color: #fff!important; }
.plan-btn.solid { background: var(--pc-primary); color: #fff!important; border: 1.5px solid var(--pc-primary); }
.plan-btn.solid:hover { background: var(--pc-primary-dark); }

/* ---------- Feature strip ---------- */
.feature-strip { position: relative; display: flex; align-items: center; margin-top: 16px; padding-right: 10px; }
.feature {
  flex: 1; display: flex; flex-direction: column; align-items: center; gap: 8px;
  font-size: 14px; font-weight: 500; text-align: center; padding: 4px 8px;
}
.feature + .feature { border-left: 1px solid #cfd8e6; }
.feature svg { width: 32px; height: 32px; fill: none; stroke: var(--pc-primary); stroke-width: 1.6; stroke-linecap: round; stroke-linejoin: round; }
.feature svg .fill { fill: var(--pc-primary); stroke: none; }
.note-bottom { position: absolute; right: 0; bottom: 0; transform: rotate(-10deg); }

/* ---------- Responsive ---------- */
@media (max-width: 1399px) {
  .plans-head { padding-right: 240px; }
  .plans-hero { width: 230px; }
  .note-top { right: 245px; }
}
@media (max-width: 1199px) {
  .plan-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 767px) {
  .plans-head { padding-right: 0; min-height: 0; }
  .plans-hero, .note-top, .note-bottom { display: none; }
  .plans-title { font-size: 25px;text-transform: capitalize; }
  .plan-grid { grid-template-columns: 1fr; gap: 22px; }
  .feature-strip { flex-wrap: wrap; padding-right: 0; row-gap: 16px; }
  .feature { flex: 0 0 50%; }
  .feature + .feature { border-left: 0; }
}
</style>